import { useHistory } from 'react-router-dom';
import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { Button } from '@givebutter/primitives/button';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LetterConfirmationDetails } from 'assets/js/pages/engage/letters/LetterConfirmationDetails';
import { LetterPreview } from 'assets/js/pages/engage/letters/LetterPreview';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { useLetterMeta } from 'assets/js/pages/engage/letters/useLetterMeta';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const LetterConfirmation = () => {
    const { isBodyEmpty, noRecipientCount } = useLetterMeta();
    const history = useHistory();
    const { accountId } = useCurrentAccount();
    const { isFetching, data: letter } = useCurrentLetter();

    return (
        <div className={'overflow-y-auto px-4'}>
            <div className={'mx-auto flex w-full max-w-3xl flex-col gap-4'}>
                <div className={'flex flex-col items-center justify-center gap-4'}>
                    {!isFetching && isBodyEmpty && (
                        <AlertNotification.Root className={'w-full'} type={'error'}>
                            <AlertNotification.Icon />
                            <AlertNotification.Content>
                                <AlertNotification.Title>
                                    The content of your letter is empty
                                </AlertNotification.Title>
                                <AlertNotification.Description>
                                    Navigate to the "Compose" step to finalize your letter’s
                                    content.
                                </AlertNotification.Description>
                                <Button
                                    variant="none"
                                    color="error"
                                    size="xs"
                                    className="font-medium"
                                    onClick={() =>
                                        history.push(
                                            `/accounts/${accountId}/engage/letters/draft/${
                                                letter!.id
                                            }/edit/compose`,
                                        )
                                    }
                                >
                                    <span>Compose letter</span>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </Button>
                            </AlertNotification.Content>
                        </AlertNotification.Root>
                    )}
                    {!isFetching && noRecipientCount && (
                        <AlertNotification.Root className={'w-full'} type={'error'}>
                            <AlertNotification.Icon />
                            <AlertNotification.Content>
                                <AlertNotification.Title>
                                    No contacts have been selected
                                </AlertNotification.Title>
                                <AlertNotification.Description>
                                    Navigate to the 'Recipients' step where you can choose the
                                    contacts for whom you'd like to generate PDF letters.
                                </AlertNotification.Description>
                                <Button
                                    variant="none"
                                    color="error"
                                    size="xs"
                                    className="font-medium"
                                    onClick={() =>
                                        history.push(
                                            `/accounts/${accountId}/engage/letters/draft/${
                                                letter!.id
                                            }/edit/filters`,
                                        )
                                    }
                                >
                                    <span>Select contacts</span>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </Button>
                            </AlertNotification.Content>
                        </AlertNotification.Root>
                    )}
                    {!isBodyEmpty && !noRecipientCount && (
                        <div className={'mb-6 flex flex-col gap-2 px-24'}>
                            <h1 className={'text-center text-3xl font-medium'}>
                                Your letter is almost finished!
                            </h1>
                            <p className={'text-center text-base text-gray-700'}>
                                Take a moment to review all of the details below to ensure their
                                accuracy. Once everything looks good, confirm your letter and
                                continue to the download page to access all of the generated PDF
                                Letters.
                            </p>
                        </div>
                    )}
                </div>
                <div className={'flex flex-col gap-4'}>
                    <LetterConfirmationDetails />
                    <LetterPreview />
                </div>
            </div>
        </div>
    );
};

export { LetterConfirmation };
